import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { SharedService } from '../../services/shared.service';
import { InvoiceService } from '../../services/invoice.service';
import { Router } from '@angular/router';
import { PatientService } from '../../services/patient.service';

@Component({
  selector: 'app-invoice-profile',
  templateUrl: './invoice-profile.component.html',
  styleUrls: ['./invoice-profile.component.css']
})
export class InvoiceProfileComponent implements OnInit {
  showErrorMessage: boolean;
  errorMessage: string;
  showLoadingMessage = false;

  /** Full list from API (active + inactive), each item has isActive */
  allPatientDtos: any[] = [];
  residentName = '';
  /** When true: show only inactive; when false: show only active */
  showOnlyInactive = false;

  constructor(
    private sharedService: SharedService,
    private router: Router,
    private patientService: PatientService,
    private invoiceService: InvoiceService
  ) {}

  ngOnInit(): void {
    this.sharedService.reloadUserPrivileges();
    this.loadAllPatientDtos();
  }

  /** Load active and inactive lists once, merge with isActive flag */
  loadAllPatientDtos(): void {
    this.showLoadingMessage = true;
    const active$ = this.patientService.getPatientDtos(
      this.sharedService.pharmacyId,
      this.sharedService.facilityId,
      this.sharedService.getUserId(),
      true
    );
    const inactive$ = this.patientService.getPatientDtos(
      this.sharedService.pharmacyId,
      this.sharedService.facilityId,
      this.sharedService.getUserId(),
      false
    );
    forkJoin([active$, inactive$]).subscribe({
      next: ([activeList, inactiveList]) => {
        activeList.forEach((p: any) => (p.isActive = true));
        inactiveList.forEach((p: any) => (p.isActive = false));
        this.allPatientDtos = [...(activeList || []), ...(inactiveList || [])];
        this.showLoadingMessage = false;
      },
      error: () => (this.showLoadingMessage = false)
    });
  }

  /** Client-side filtered list: by Show Only Inactive and by Resident Name (case-insensitive) */
  get filteredPatientDtos(): any[] {
    if (!this.allPatientDtos || this.allPatientDtos.length === 0) return [];
    let list = this.showOnlyInactive
      ? this.allPatientDtos.filter((p) => !p.isActive)
      : this.allPatientDtos.filter((p) => p.isActive);
    const term = (this.residentName || '').trim().toLowerCase();
    if (term) {
      list = list.filter((p) => {
        const fullName = `${p.lastName || ''} ${p.firstName || ''}`.toLowerCase();
        const fullNameReversed = `${p.firstName || ''} ${p.lastName || ''}`.toLowerCase();
        return fullName.includes(term) || fullNameReversed.includes(term);
      });
    }
    return list;
  }

  openProfile(patientId: number): void {
    const url = `invoice/profile/${this.sharedService.pharmacyId}/${this.sharedService.facilityId}/${patientId}`;
    this.router.navigate([url]);
  }

  clearErrorMessage(): void {
    this.showErrorMessage = false;
    this.errorMessage = '';
  }
}
